import { render, staticRenderFns } from "./reportManagement.vue?vue&type=template&id=51178a7c&scoped=true"
import script from "./reportManagement.vue?vue&type=script&lang=js"
export * from "./reportManagement.vue?vue&type=script&lang=js"
import style0 from "./reportManagement.vue?vue&type=style&index=0&id=51178a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51178a7c",
  null
  
)

export default component.exports